export default __webpack_public_path__ + "static/media/Presc.c263c3fe.svg";